var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotorcycle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_1199)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 13C23.3344 13 23 13.3343 23 13.75C23 14.1656 23.3344 14.5 23.75 14.5H25.5531L26.0656 15.4468L23 18L21.5844 16.5843C21.2094 16.2093 20.7 16 20.1687 16H17C16.4469 16 16 16.4468 16 17V18H19C21.7625 18 24 20.2375 24 23C24 23.3437 23.9656 23.6781 23.9 24H26.1C26.0344 23.6781 26 23.3437 26 23C26 21.3687 26.7813 19.9187 27.9906 19.0062L28.4719 19.9C27.575 20.6343 27 21.75 27 23C27 25.2093 28.7906 27 31 27C33.2094 27 35 25.2093 35 23C35 20.7906 33.2094 19 31 19C30.5781 19 30.1719 19.0656 29.7906 19.1875L28.0688 16H30C30.5531 16 31 15.5531 31 15V14C31 13.4468 30.5531 13 30 13H29.3625C29.1281 13 28.9031 13.0812 28.7219 13.2312L27.2406 14.4656L26.8031 13.6531C26.5844 13.25 26.1625 12.9968 25.7031 12.9968H23.75V13ZM29.4594 21.725L30.3406 23.3562C30.5375 23.7218 30.9938 23.8562 31.3563 23.6593C31.7188 23.4625 31.8562 23.0062 31.6594 22.6437L30.7781 21.0125C30.85 21.0031 30.925 21 31 21C32.1031 21 33 21.8968 33 23C33 24.1031 32.1031 25 31 25C29.8969 25 29 24.1031 29 23C29 22.5156 29.1719 22.0718 29.4594 21.725ZM20.8531 23.75C20.5563 24.4843 19.8375 25 19 25C17.8969 25 17 24.1031 17 23C17 21.8968 17.8969 21 19 21C19.8406 21 20.5594 21.5156 20.8531 22.25H22.9281C22.5781 20.4 20.9531 19 19 19C16.7906 19 15 20.7906 15 23C15 25.2093 16.7906 27 19 27C20.9531 27 22.5781 25.6 22.9313 23.75H20.8531ZM19 24C19.5531 24 20 23.5531 20 23C20 22.4468 19.5531 22 19 22C18.4469 22 18 22.4468 18 23C18 23.5531 18.4469 24 19 24Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_1199",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_1199"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorcycle);
export default __webpack_public_path__ + "static/media/motorcycle.84f5dd7cd7aa2c9e42d190b1d8b33ba2.svg";
export { ForwardRef as ReactComponent };